'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_index', {
    url: 'demand_index',
    template: '<demand-index></demand-index>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/demand/index/demand_index.routes.js